import type { FaireProductEntity } from "../../entity_types/product";

export const p_muqzfjnpng: FaireProductEntity = {
  token: "p_muqzfjnpng",
  type: "product",
  name: "LM-CT-1001 Puffer Jacket  - Black",
  brandToken: "b_h6l667zq",
  brandName: "Girlie Girl Originals",
  imageUrl: "https://cdn.faire.com/fastly/81f7e2aa91fd148bb96fc487eab0f10d4721b4964869d38676409b66c60259cf.jpeg",
  galleryImageUrls: [],
  priceDollars: 44.5,
  description: "This women's puffer jacket by Girlie Girl Originals delivers dependable warmth with a clean silhouette designed for wear. It offers a versatile look in Black and maintains the brand's bold, fun style suited for boutiques and retailers.",
  tags: [],
  msrpDollars: 89,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-10-28T21:01:19.550Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
